import { Component, ErrorInfo, ReactNode } from 'react';

import { getLogger } from '@/log';

const log = getLogger('error-boundary');

interface State {
    error: Error | null;
    info: ErrorInfo | null;
}

export class RootErrorBoundary extends Component<{ children: ReactNode }, State> {
    state: State = { error: null, info: null };

    static getDerivedStateFromError(error: Error): State {
        return { error, info: null };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        this.setState({ error, info });
        log.error(error, info);
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: '2rem', fontFamily: 'ui-monospace, monospace' }}>
                    <h1 style={{ color: '#dc2626' }}>App crashed while rendering</h1>
                    <p>{this.state.error.message}</p>
                    <pre style={{ whiteSpace: 'pre-wrap', background: '#f1f5f9', padding: '1rem', borderRadius: '0.5rem', fontSize: '0.8125rem' }}>
                        {this.state.error.stack}
                    </pre>
                    {this.state.info?.componentStack ? (
                        <details>
                            <summary>Component stack</summary>
                            <pre style={{ whiteSpace: 'pre-wrap', fontSize: '0.8125rem' }}>{this.state.info.componentStack}</pre>
                        </details>
                    ) : null}
                </div>
            );
        }
        return this.props.children;
    }
}
